
import {
    Box,
    FormControl,
    FormLabel,
    TextField,
    Button,
    Stack,
    IconButton
} from "@mui/material";
import { useState, ChangeEvent } from "react";
import toast, { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import PersistentDrawerLeft from "./Leftmenu";

interface FormDataType {
    bannerImageName: string;
    bannerImageFile: File[];
}

export default function BannerForm() {
    const [drawerOpen, setDrawerOpen] = useState<boolean>(true);

    const [formData, setFormData] = useState<FormDataType>({
        bannerImageName: "",
        bannerImageFile: [],
    });

    const handleOnEvent = (event: ChangeEvent<HTMLInputElement>) => {
        const { name, value } = event.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleImageUpload = (event: ChangeEvent<HTMLInputElement>) => {
        const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2 MB

        const files = event.target.files ? Array.from(event.target.files) : [];

        const imageValidation = ['image/jpeg', 'image/jpg'];

        if (!files.length) return;

        const file = files[0];

        if (!imageValidation.includes(file.type)) {
            toast.error('Only jpeg and jpg are allowed');
            return;
        }

        if (file.size > MAX_FILE_SIZE) {
            toast.error('Image should be less than 2 MB');
            return;
        }

        setFormData((prev) => ({
            ...prev,
            bannerImageFile: [...(prev.bannerImageFile || []), ...files]
        }));
    };

    const handleRemoveImage = (indexToRemove: number) => {
        setFormData((prev) => ({
            ...prev,
            bannerImageFile: prev.bannerImageFile.filter((_, index) => index !== indexToRemove)
        }));
    };

    const handleSubmit = () => {
        if (!formData.bannerImageName || !formData.bannerImageFile.length) {
            toast.error("Please fill in all required fields!");
            return;
        }

        toast.success("Banner saved successfully!");
      
    };

    const resultCheck = Array.isArray(formData.bannerImageFile) && formData.bannerImageFile.length > 0;

    return (
        <>
            <PersistentDrawerLeft open={drawerOpen} setOpen={setDrawerOpen} />
            <Toaster />

            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, maxWidth: 400, margin: "auto", mt: 4 }}>
                <FormControl fullWidth>
                    <FormLabel htmlFor="banner-image">Banner Image</FormLabel>
                    <TextField
                        id="banner-image"
                        type="text"
                        name="bannerImageName"
                        placeholder="Image Name"
                        autoComplete="off"
                        required
                        fullWidth
                        variant="outlined"
                        value={formData.bannerImageName}
                        onChange={handleOnEvent}
                    />
                </FormControl>

                <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    alignItems="center"
                    sx={{ mt: 2 }}
                >
                    <Button
                        variant="contained"
                        component="label"
                        size="large"
                        sx={{ minWidth: 110, fontSize: "0.75rem" }}
                    >
                        {formData.bannerImageFile.length === 0 ? "Upload Image" : "Uploaded"}
                        <input
                            type="file"
                            hidden
                            onChange={handleImageUpload}
                            disabled={resultCheck}
                            accept="image/jpeg,image/jpg"
                        />
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{ minWidth: 120 }}
                        onClick={handleSubmit}
                    >
                        Save
                    </Button>

                    <Button
                        variant="outlined"
                        color="secondary"
                        size="large"
                        sx={{ minWidth: 120 }}
                        onClick={() => setFormData({ bannerImageName: "", bannerImageFile: [] })}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        color="primary"
                        size="large"
                        sx={{ minWidth: 120 }}
                        component={Link}
                        to="/bannerFormList"
                    >
                        List
                    </Button>
                </Stack>

                {formData.bannerImageFile.length > 0 && (
                    <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
                        {formData.bannerImageFile.map((file, index) => (
                            <Box
                                key={index}
                                sx={{
                                    position: "relative",
                                    width: 100,
                                    height: 100,
                                    borderRadius: 2,
                                    overflow: "hidden"
                                }}
                            >
                                <img
                                    src={URL.createObjectURL(file)}
                                    alt="Preview"
                                    width="100%"
                                    height="100%"
                                    style={{ objectFit: "cover", border: "1px solid #ccc" }}
                                />
                                <IconButton
                                    size="small"
                                    sx={{
                                        position: "absolute",
                                        top: 2,
                                        right: 2,
                                        background: "rgba(0,0,0,0.5)",
                                        color: "white",
                                        fontSize: 14
                                    }}
                                    onClick={() => handleRemoveImage(index)}
                                >
                                    ❌
                                </IconButton>
                            </Box>
                        ))}
                    </Box>
                )}
            </Box>
        </>
    );
}
